<template>
  <el-button v-bind="$attrs" :type="type" class="yj-button">
    <img v-if="iconUrl" :src="iconUrl" class="yj-button__icon" :alt="icon" />
    <span v-if="$slots.default" class="yj-button__text">
      <slot />
    </span>
  </el-button>
</template>

<script setup lang="ts">
/**
 * 业务按钮：基于 el-button 封装，icon 通过名称映射 public/images/{name}.webp
 * 用法：<YjButton type="primary" icon="export">导出</YjButton>
 */
import { computed } from 'vue';

defineOptions({ name: 'YjButton', inheritAttrs: false });

const props = defineProps<{
  /** public/images 下的图片名（不含扩展名），如 'export'、'import' */
  icon?: string;
  /** el-button type，透传 */
  type?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'default';
}>();

const iconUrl = computed(() => (props.icon ? `/images/${props.icon}.webp` : ''));
</script>

<style lang="scss" scoped>
.yj-button {
  display: inline-flex;
  align-items: center;

  .yj-button__icon {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }

  .yj-button__icon + .yj-button__text {
    margin-left: 6px;
  }
}
</style>
